import { getApiUrl } from '@/api/apiClient.js';

const BASE = '/api/transfers';

export default {
  getAll: () => getApiUrl(`${BASE}`),
  getById: (id) => getApiUrl(`${BASE}/${id}`),
  getFiles: (id) => getApiUrl(`${BASE}/${id}/files`),
  requestFile: (id, featureCategory) => getApiUrl(`${BASE}/${id}/files/${featureCategory}`),
  getTransferReservations: (id) => getApiUrl(`${BASE}/${id}/reservations`),
};
